export default function ErrorMessage({ children }) {
    return (
        <div className="  text-[#F04438] text-[12px] text-left">
            {children}
        </div>
    )
};
